<template>
  <div class="device-settings-view">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Device Settings</h1>
          <p>Gestión de configuraciones de dispositivos</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="deviceSettingsList"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lista de Configuraciones de Dispositivos</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="refreshData">
                  <v-icon left>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.online="{ item }">
              <v-chip :color="item.online ? 'success' : 'error'" small>
                {{ item.online ? 'En línea' : 'Desconectado' }}
              </v-chip>
            </template>
            <template v-slot:item.active="{ item }">
              <v-chip :color="item.active ? 'success' : 'warning'" small>
                {{ item.active ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>
            <template v-slot:item.calculated="{ item }">
              <v-chip :color="item.calculated ? 'info' : 'default'" small>
                {{ item.calculated ? 'Calculado' : 'Directo' }}
              </v-chip>
            </template>
            <template v-slot:item.initDate="{ item }">
              {{ formatDate(item.initDate) }}
            </template>
            <template v-slot:item.endDate="{ item }">
              {{ formatDate(item.endDate) }}
            </template>
            <template v-slot:item.sensorSettings="{ item }">
              <v-chip color="blue" small>
                {{ Array.isArray(item.sensorSettings) ? item.sensorSettings.length : 0 }} sensores
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useDeviceSettingsStore } from './store'
import { DeviceSettings } from './models/deviceSettings'

const deviceSettingsStore = useDeviceSettingsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Dispositivo ID', key: 'deviceId' },
  { title: 'Nombre Config', key: 'configName' },
  { title: 'En línea', key: 'online' },
  { title: 'Activo', key: 'active' },
  { title: 'Separador', key: 'separator' },
  { title: 'Sensores', key: 'sensorSettings' },
  { title: 'Intervalo', key: 'interval' },
  { title: 'Fecha Inicio', key: 'initDate' },
  { title: 'Fecha Fin', key: 'endDate' },
  { title: 'Formato TS', key: 'timestampFormat' },
  { title: 'Origen', key: 'origin' },
  { title: 'Calculado', key: 'calculated' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const deviceSettingsList = computed(() => deviceSettingsStore.deviceSettings)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES')
}

const refreshData = async () => {
  loading.value = true
  try {
    await deviceSettingsStore.getDeviceSettings()
  } finally {
    loading.value = false
  }
}

const editItem = (item: DeviceSettings) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: DeviceSettings) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})
</script>

<style scoped>
.device-settings-view {
  height: 100%;
}
</style>
